import React, { useContext, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Upload } from 'antd'
import { FlexBox } from 'components/Box'
import { Modal } from 'components/CustomModal'
import { infoToast, ToastContext } from 'components/Toast/Toast'
import { useApiClient } from 'utils/api/ApiClient'
import { PartnershipsApiClient } from 'utils/api/partnershipsApi'

import { MatchParams } from './Details/IntroducingBrokerProfile/types'

interface LeadsImportModalProps {
  visible: boolean

  onResolve(): void
  onClose(): void
}

export const StandardCommissionsImportModal: React.FC<LeadsImportModalProps> = (props) => {
  const params = useParams<MatchParams>()
  const partnershipsApiClient = useApiClient(PartnershipsApiClient)
  const setToast = useContext(ToastContext)

  const [fileInfo, setFileInfo] = useState<File>()
  const isFileSelected = !!fileInfo

  const handleSelectFile = (file: File) => {
    if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
      setToast(infoToast('Supported format is only csv.'))
      return false
    }
    setFileInfo(file)

    return false
  }

  const handleUploadFile = async () => {
    if (fileInfo) {
      const formData = new FormData()
      formData.append('file', fileInfo, 'file.csv')
      params.id
        ? await partnershipsApiClient.uploadIntroducingBrokerProfileByIdUploadStandardCommissions(
            params.id,
            formData
          )
        : Promise.resolve()
      props.onResolve()
    }
  }

  return (
    <Modal width={900} visible={props.visible} onClose={props.onClose}>
      <FlexBox margin={24}>
        <Upload beforeUpload={handleSelectFile} showUploadList={false}>
          <Button type='button'>{fileInfo?.name ? fileInfo?.name : <>Select File ...</>}</Button>
        </Upload>
        <Button type='button' onClick={handleUploadFile} disabled={!isFileSelected}>
          Upload
        </Button>
      </FlexBox>
    </Modal>
  )
}
